class FeedInsta extends HTMLElement {
  constructor() {
    super();
    new Swiper(".feed-insta .swiper", {
        slidesPerView: "auto",
        spaceBetween: 12,
        roundLengths: true,
        initialSlide: 2,
        loop: true,
        centeredSlides: true,
        navigation: {
          nextEl: document.querySelector(".feed-insta__left .swiper-button-next"),
          prevEl: document.querySelector(".feed-insta__left .swiper-button-prev"),
        },
        pagination: {
          el: document.querySelector(".feed-insta__left .swiper-pagination"),
          clickable: true,
        },
        breakpoints: {
          990: {
            centeredSlides: false,
            spaceBetween: 18,
            loop: true,
          },
        },
      });
  }
}
  
customElements.define('feed-insta', FeedInsta);
